/** @format */

const PREFIJO = 'lusazu.gestorOT.v1.';

/**
 * localStorage puede fallar (modo privado, cuota llena) y una preferencia
 * corrupta no debe dejar la pantalla inutilizable: ante cualquier duda se
 * devuelve el valor por defecto.
 */
export const leerPreferencia = (clave, porDefecto) => {
	try {
		const guardado = window.localStorage.getItem(PREFIJO + clave);
		if (!guardado) return porDefecto;
		const valor = JSON.parse(guardado);
		if (valor === null || typeof valor !== typeof porDefecto) return porDefecto;
		if (Array.isArray(porDefecto) !== Array.isArray(valor)) return porDefecto;
		return valor;
	} catch (e) {
		return porDefecto;
	}
};

export const guardarPreferencia = (clave, valor) => {
	try {
		window.localStorage.setItem(PREFIJO + clave, JSON.stringify(valor));
	} catch (e) {
		// sin persistencia la pantalla sigue funcionando
	}
};
